// extracted by mini-css-extract-plugin
module.exports = {"form":"CreateUser_form__maW4g","inputs":"CreateUser_inputs__1I1ir","error":"CreateUser_error__1Fr7F"};